export const businessTypes = [
  {
    type: "Real Estate Broker",
    subtype: "Property Transaction Facilitator",
    icon: "svg/Estate-icon2.svg",
    subtypes: [
      "Property Dealer",
      "Real Estate Consultant",
      "Property Advisor",
      "Realtor",
      "Real Estate Agent",
      "Property Facilitator",
      "Estate Agent",
      "Housing Consultant",
      "Land & Property Consultant",
      "Realty Specialist",
      "Real Estate Broker"
    ],
  },
  {
    type: "Restaurant",
    subtype: "Food Service Establishment",
    icon: "svg/restaurant-icon2.svg",
    subtypes: [
      "Fine Dining",
      "Casual Dining",
      "Café",
      "Fast Food",
      "Buffet Restaurant",
      "Family Restaurant",
      "Food Court Outlet",
      "Takeaway Restaurant",
      "Cloud Kitchen",
      "Bistro",
      "Restaurant"
    ],
  },
  {
    // Online stores (Shopify App Store merchants). The `type` "E-commerce" must
    // match the "E-commerce" key in the backend agentPromptTemplates so the
    // e-commerce voice prompt (product/order/support + shopify_* tools) is used.
    type: "E-commerce",
    subtype: "Online Store",
    icon: "svg/e-commerce_icon.svg",
    subtypes: [
      "Online Store",
      "Shopify Store",
      "E-commerce Store",
      "D2C Brand",
      "Online Retailer",
      "Dropshipping Store",
      "Boutique Online Store",
      "Subscription Box Store",
      "Print on Demand Store",
      "E-commerce"
    ],
  },
  {
    type: "Interior Designer",
    subtype: "Indoor Space Beautifier",
    icon: "svg/Interior-Designer-icon2.svg",
    subtypes: [
      "Residential Interior Designer",
      "Commercial Interior Designer",
      "Office Space Designer",
      "Kitchen & Bath Designer",
      "Luxury Interior Designer",
      "Space Planner",
      "Home Decor Specialist",
      "Furniture Designer",
      "Lighting Designer",
      "Theme-Based Designer",
      "Interior Designer"
    ],
  },
  {
    type: "Salon",
    subtype: "Hair Styling & Grooming",
    icon: "svg/salon-icon2.svg",
    subtypes: [
      "Unisex Salon",
      "Men’s Salon",
      "Women’s Salon",
      "Hair Cutting Specialist",
      "Beauty Salon",
      "Makeup Studio",
      "Spa & Wellness Center",
      "Nail Salon",
      "Bridal Salon",
      "Skin Care Studio",
      "Hair Styling & Grooming",
      "Salon"
    ],
  },
  {
    type: "Landscaping Company",
    subtype: "Outdoor Space Beautification",
    icon: "svg/Landscaping-icon2.svg",
    subtypes: [
      "Garden Designer",
      "Landscape Architect",
      "Lawn Care Specialist",
      "Irrigation & Water Features Expert",
      "Hardscape Contractor",
      "Tree Care & Plantation",
      "Outdoor Lighting Designer",
      "Patio & Deck Builder",
      "Vertical Garden Specialist",
      "Sustainable Landscaping Expert",
      "Landscaping Company"
    ],
  },
  {
    type: "Dentist",
    subtype: "Dental Care Provider",
    icon: "svg/dentist-icon2.svg",
    subtypes: [
      "General Dentist",
      "Orthodontist",
      "Cosmetic Dentist",
      "Prosthodontist",
      "Pediatric Dentist",
      "Endodontist",
      "Periodontist",
      "Oral Surgeon",
      "Implant Specialist",
      "Dental Hygienist",
      "Dentist"
    ],
  },
  // {
  //   type: "Doctor's Clinic",
  //   subtype: "Medical Consultation & Treatment",
  //   icon: "svg/Doctor-clinic-icon.svg",
  //   subtypes: [
  //     "General Physician",
  //     "Pediatrician",
  //     "Dermatologist",
  //     "Cardiologist",
  //     "Orthopedic Doctor",
  //     "ENT Specialist",
  //     "Neurologist",
  //     "Gynecologist",
  //     "Diabetologist",
  //     "Family Doctor",
  //     "Doctor's Clinic"
  //   ],
  // },
  // business categories
  {
    type: "Gym & Fitness Center",
    subtype: "Exercise Facility & Training",
    icon: "svg/Gym-icon2.svg",
    subtypes: [
      "CrossFit Gym",
      "Yoga Studio",
      "Pilates Studio",
      "Zumba Fitness",
      "Martial Arts Center",
      "Bodybuilding Gym",
      "Personal Training Studio",
      "Wellness Club",
      "Aerobics Center",
      "Functional Training Gym",
      "Gym & Fitness Center"
    ],
  },

  {
    type: "Personal Trainer",
    subtype: "Individual Fitness Coaching",
    icon: "svg/Personal Trainer2.svg",
    subtypes: [
      "Strength Coach",
      "Yoga Instructor",
      "Weight Loss Coach",
      "Rehabilitation Trainer",
      "Sports Trainer",
      "Nutrition & Fitness Coach",
      "Online Fitness Trainer",
      "Body Transformation Coach",
      "Cardio Trainer",
      "Flexibility & Mobility Coach",
      "Personal Trainer"
    ],
  },
  {
    type: "Web Design Agency",
    subtype: "Website Creation & Development",
    icon: "svg/Web Design Agency2.svg",
    subtypes: [
      "UI/UX Designer",
      "Frontend Developer",
      "Backend Developer",
      "Full Stack Developer",
      "E-commerce Website Developer",
      "WordPress Developer",
      "Shopify Developer",
      "Mobile App UI Designer",
      "Landing Page Designer",
      "Custom Website Developer",
      "Web Design Agency"
    ],

  },
  {
    type: "Architect",
    subtype: "Building Design Expert",
    icon: "svg/Architect-icon2.svg",
    subtypes: [
      "Residential Architect",
      "Commercial Architect",
      "Industrial Architect",
      "Urban Planner",
      "Sustainable Architect",
      "Interior Architect",
      "Restoration Architect",
      "Healthcare Facility Architect",
      "Educational Facility Architect",
      "Architect"
    ],
  },
  {
    type: "Property Rental & Leasing Service",
    subtype: "Property Rental Management",
    icon: "svg/Property Rental & Leasing Service2.svg",
    subtypes: [
      "Residential Property Rental",
      "Commercial Property Leasing",
      "Vacation Rental Management",
      "Corporate Leasing",
      "Apartment Leasing",
      "Villa & Bungalow Rentals",
      "Student Accommodation Rentals",
      "Retail Space Leasing",
      "Short-Term Rentals",
      "Long-Term Rentals",
      "Property Rental & Leasing Service"
    ],
  },
  {
    type: "Construction Services",
    subtype: "Building Construction & Repair",
    icon: "svg/Construction Services2.svg",
    subtypes: [
      "Residential Construction",
      "Commercial Construction",
      "Civil Engineering Contractor",
      "Renovation & Remodeling",
      "Road & Highway Construction",
      "Bridge & Infrastructure Builder",
      "Masonry & Concrete Work",
      "Plumbing & Electrical Contractor",
      "Painting & Finishing",
      "Demolition Services",
      "Construction Services"
    ],
  },
  {
    type: "Insurance Agency",
    subtype: "Risk Protection Provider",
    icon: "svg/Insurance Agency2.svg",
    subtypes: [
      "Life Insurance Agent",
      "Health Insurance Consultant",
      "Motor Insurance Provider",
      "Home Insurance Specialist",
      "Travel Insurance Agent",
      "Commercial Insurance Advisor",
      "Liability Insurance Consultant",
      "Property Insurance Broker",
      "Accident Insurance Provider",
      "Corporate Insurance Solutions",
      "Insurance Agency"
    ],
  },
  {
    type: "Old Age Home",
    subtype: "Senior Living Facility",
    icon: "svg/Old Age Home2.svg",
    subtypes: [
      "Assisted Living Facility",
      "Nursing Home",
      "Independent Senior Living",
      "Memory Care Facility",
      "Hospice Care Center",
      "Retirement Community",
      "Day Care for Seniors",
      "Long-Term Care Facility",
      "Rehabilitation Center",
      "Old Age Home"
    ],
  },
  {
    type: "Travel Agency",
    subtype: "Trip Planning & Booking",
    icon: "svg/Travel Agency2.svg",
    subtypes: [
      "Domestic Travel Agent",
      "International Travel Consultant",
      "Corporate Travel Agency",
      "Adventure Travel Specialist",
      "Pilgrimage Tour Operator",
      "Luxury Travel Planner",
      "Honeymoon Travel Consultant",
      "Cruise Booking Agency",
      "Visa & Immigration Assistance",
      "Group Tour Organizer",
      "Travel Agency"
    ],
  },
  {
    type: "Ticket Booking",
    subtype: "Travel Ticket Provider",
    icon: "svg/Ticket Booking2.svg",
    subtypes: [
      "Flight Ticket Booking",
      "Train Ticket Booking",
      "Bus Ticket Booking",
      "Movie Ticket Booking",
      "Event Ticket Booking",
      "Concert Ticket Booking",
      "Sports Ticket Booking",
      "Cruise Ticket Booking",
      "Tour Package Booking",
      "Online Ticket Aggregator",
      "Ticket Booking"
    ],
  },
  {
    type: "Accounting Services",
    subtype: "Financial Record Management",
    icon: "svg/Accounting Services2.svg",
    subtypes: [
      "Bookkeeping Services",
      "Tax Preparation & Filing",
      "Payroll Management",
      "Auditing Services",
      "Financial Reporting",
      "Accounts Payable & Receivable",
      "GST & VAT Filing",
      "Budget Planning",
      "Forensic Accounting",
      "Corporate Accounting",
      "Accounting Services"
    ],
  },
  {
    type: "Financial Planners",
    subtype: "Wealth Management Advice",
    icon: "svg/Financial Planners2.svg",
    subtypes: [
      "Retirement Planning",
      "Investment Advisory",
      "Tax Planning",
      "Estate Planning",
      "Insurance Planning",
      "Wealth Management",
      "Mutual Funds Advisory",
      "Stock Market Consultant",
      "Debt Management Advisor",
      "College Fund Planning",
      "Financial Planners"

    ],
  },
  {
    type: "Beauty Parlour",
    subtype: "Cosmetic Beauty Services",
    icon: "svg/Beauty Parlour2.svg",
    subtypes: [
      "Facial & Skincare",
      "Hair Styling & Coloring",
      "Bridal Makeup",
      "Threading & Waxing",
      "Pedicure & Manicure",
      "Spa Treatments",
      "Mehndi Artist",
      "Anti-Aging Treatments",
      "Body Polishing",
      "Party Makeup Services",
      "Beauty Parlour"
    ],
  },
  {
    type: "Nail Salon",
    subtype: "Manicure/Pedicure Services",
    icon: "svg/Nail Saloon.svg",
    subtypes: [
      "Basic Manicure",
      "Basic Pedicure",
      "Gel Nails",
      "Acrylic Nails",
      "Nail Art Design",
      "French Manicure",
      "Luxury Spa Pedicure",
      "Nail Repair",
      "3D Nail Art",
      "Cuticle Treatment",
      "Nail Salon"
    ],
  },
  {
    type: "Barber Studio/Shop",
    subtype: "Men's Hair Grooming",
    icon: "svg/Barber2.svg",
    subtypes: [
      "Men’s Haircut",
      "Beard Trimming",
      "Shaving Services",
      "Hair Coloring for Men",
      "Head Massage",
      "Hot Towel Shave",
      "Kids Haircut",
      "Classic Styling",
      "Fading & Tapering",
      "Beard Styling",
      "Barber Studio/Shop"
    ],
  },
  {
    type: "Hair Stylist",
    subtype: "Professional Hair Care",
    icon: "svg/Hair Stylist2.svg",
    subtypes: [
      "Women’s Haircut",
      "Hair Coloring",
      "Hair Straightening",
      "Hair Smoothening",
      "Keratin Treatment",
      "Bridal Hair Styling",
      "Kids Hair Styling",
      "Hair Extensions",
      "Blow Dry Specialist",
      "Curly Hair Specialist",
      "Hair Stylist"
    ],
  },
  {
    type: "Bakery",
    subtype: "Baked Goods Producer",
    icon: "svg/Bakery2.svg",
    subtypes: [
      "Bread Bakery",
      "Cake Shop",
      "Pastry Shop",
      "Cupcake Bakery",
      "Artisan Bakery",
      "Gluten-Free Bakery",
      "Dessert Café",
      "Wholesale Bakery",
      "Wedding Cake Specialist",
      "Custom Cake Designer",
      "Bakery"
    ],
  },
  {
    type: "Dry Cleaners",
    subtype: "Garment Cleaning & Care",
    icon: "svg/Dry Cleaner2.svg",
    subtypes: [
      "Laundry Services",
      "Suit & Blazer Cleaning",
      "Wedding Dress Cleaning",
      "Carpet Cleaning",
      "Curtain Cleaning",
      "Stain Removal Expert",
      "Shoe & Leather Cleaning",
      "Express Dry Cleaning",
      "Corporate Laundry Services",
      "Home Pickup & Delivery",
      "Dry Cleaners"
    ],
  },
  {
    type: "Cleaning and Janitorial Services",
    subtype: "Professional Cleaning Solutions",
    icon: "svg/Cleaning Janitorial Service2.svg",
    subtypes: [
      "Residential Cleaning",
      "Office Cleaning",
      "Deep Cleaning",
      "Carpet & Upholstery Cleaning",
      "Window Cleaning",
      "Move-in/Move-out Cleaning",
      "Industrial Cleaning",
      "Disinfection Services",
      "Post-Construction Cleaning",
      "Green/Eco-Friendly Cleaning",
      "Cleaning and Janitorial Services"
    ],
  },
  {
    type: "Tour Guides",
    subtype: "Local Experience Experts",
    icon: "svg/Tour-Guides2.svg",
    subtypes: [
      "City Tour Guide",
      "Historical Tour Guide",
      "Adventure Tour Guide",
      "Wildlife/Nature Guide",
      "Museum Guide",
      "Cultural Experience Guide",
      "Food Tour Guide",
      "Religious/Heritage Tour Guide",
      "Private Tour Guide",
      "Group Tour Organizer",
      "Tour Guides"
    ],
  },
  {
    type: "Deli Shop",
    subtype: "Fresh Meats & Gourmet Foods",
    icon: "svg/Deli shop2.svg",
    subtypes: [
      "Meat Deli",
      "Cheese Shop",
      "Sandwich Deli",
      "Gourmet Foods Deli",
      "Seafood Deli",
      "Charcuterie Specialist",
      "Organic Deli",
      "International Deli",
      "Salad Bar Deli",
      "Hot & Cold Cuts Deli",
      "Deli Shop"
    ],
  },
  {
    type: "Marketing Agency",
    subtype: "Your Journey Begins Here",
    icon: "svg/Marketing Agency2.svg",
    subtypes: [
      "Branding Agency",
      "Advertising Agency",
      "Creative Agency",
      "Public Relations Agency",
      "Media Buying Agency",
      "Design & Graphics Agency",
      "Content Marketing Agency",
      "Offline Marketing Agency",
      "Promotions & Event Marketing",
      "Corporate Marketing Services",
      "Marketing Agency"
    ],
  },
  {
    type: "Digital Marketing Agency",
    subtype: "Grow Your Brand Online",
    icon: "svg/Digital-marketing-Agency2.svg",
    subtypes: [
      "SEO Agency",
      "Social Media Marketing Agency",
      "PPC & Ads Agency",
      "Content Marketing Agency",
      "Email Marketing Agency",
      "Influencer Marketing Agency",
      "Web Analytics Agency",
      "E-commerce Marketing Agency",
      "Video Marketing Agency",
      "Full-Service Digital Agency",
      "Digital Marketing Agency"
    ],
  },
  {
    type: "Car Repair & Garage",
    subtype: "Quality Repairs, Every Time",
    icon: "svg/Car Repair & Garage2.svg",
    subtypes: [
      "General Auto Repair",
      "Engine Repair Specialist",
      "Transmission Repair",
      "Brake & Clutch Services",
      "Car AC Repair",
      "Oil Change & Maintenance",
      "Car Electrical Repair",
      "Body & Paint Shop",
      "Tyre & Wheel Alignment",
      "Car Detailing & Washing",
      "Car Repair & Garage"
    ],
  },
  {
    type: "Boat Repair",
    subtype: "Marine Care & Repair Experts",
    icon: "svg/Boat Repair & Maintenance2.svg",
    subtypes: [
      "Engine Repair",
      "Hull Repair",
      "Electrical System Repair",
      "Propeller & Shaft Repair",
      "Fiberglass Repair",
      "Boat Painting & Detailing",
      "Navigation System Repair",
      "Fuel System Maintenance",
      "Marine Upholstery Repair",
      "Boat Winterization & Storage",
      "Boat Repair"
    ],

  },
  {
    type: "Car & Bus Services",
    subtype: "Quality Repairs, Every Time",
    icon: "svg/Car & Bus Services2.svg",
    subtypes: [
      "General Car Service",
      "Bus Maintenance",
      "Brake & Suspension Repair",
      "Engine Diagnostics",
      "AC & Cooling Repair",
      "Oil Change & Tune-Up",
      "Body & Paint Services",
      "Tyre Replacement & Alignment",
      "Battery Replacement",
      "Fleet Maintenance",
      "Car & Bus Services"
    ],

  },
  {
    type: "Taxi, Cab & Limo Booking",
    subtype: "Reliable Rides, Anytime, Anywhere",
    icon: "svg/Taxi2.svg",
    subtypes: [
      "Local Taxi Service",
      "Airport Cab Service",
      "Luxury Limo Rental",
      "Outstation Cabs",
      "Ride Sharing Service",
      "Hourly Cab Rentals",
      "Corporate Taxi Service",
      "Event Transportation",
      "Tourist Cab Service",
      "24/7 Emergency Taxi",
      "Taxi, Cab & Limo Booking"
    ],

  },
  {
    type: "Taxi Service",
    subtype: "Reliable Rides, Anytime, Anywhere",
    icon: "svg/Taxi2.svg",
    subtypes: [
      "Local City Taxi",
      "Outstation Taxi",
      "Airport Pickup & Drop",
      "Railway Station Transfer",
      "Hourly Rental Taxi",
      "Corporate Taxi Service",
      "Wedding & Event Taxi",
      "Luxury Car Rental",
      "SUV & MUV Taxi Service",
      "Shared Cab Service",
      "One Way Taxi",
      "Round Trip Taxi",
      "Taxi Service"
    ],

  },
  {
    type: "Limo Booking",
    subtype: "Luxury Rides for Premium Experiences",
    icon: "svg/Taxi2.svg",
    subtypes: [
      "Airport Limo Transfer",
      "Corporate Limo Service",
      "Wedding Limo Booking",
      "Party & Event Limo",
      "Prom Night Limo",
      "Hourly Limo Rental",
      "City Tour Limo",
      "Outstation Limo Service",
      "VIP & Celebrity Transport",
      "Chauffeur Driven Limo",
      "Luxury Stretch Limousine",
      "Executive Sedan Limo",
      "Limo Booking"
    ],
  },
  {
    type: "Movers and Packers",
    subtype: "Safe & Hassle-Free Relocation Services",
    icon: "svg/Movers and Packers2.svg",
    subtypes: [
      "Household Shifting",
      "Office Relocation",
      "Local Shifting",
      "Intercity Moving",
      "International Relocation",
      "Packing & Unpacking",
      "Loading & Unloading",
      "Furniture Disassembly & Assembly",
      "Vehicle Transportation",
      "Storage & Warehousing",
      "Movers and Packers"
    ],

  },
  {
    type: "Trucking Company",
    subtype: "Efficient Freight & Logistics Solutions",
    icon: "svg/Trucking Company2.svg",
    subtypes: [
      "Freight Transport Services",
      "Logistics & Distribution",
      "Refrigerated Trucking",
      "Flatbed Trucking",
      "Container Hauling",
      "Long-Haul Trucking",
      "Local Delivery Trucks",
      "Hazardous Material Transport",
      "Courier & Parcel Services",
      "Supply Chain Solutions",
      "Trucking Company"
    ],
  },
  {
    type: "Spa & Wellness Center",
    subtype: "Relaxation & Health Services",
    icon: "svg/Hair Stylist2.svg",
    subtypes: [
      "Day Spa",
      "Ayurvedic Spa",
      "Luxury Spa",
      "Massage Therapy Center",
      "Wellness Retreat",
      "Beauty & Wellness Spa",
      "Skin & Body Care Spa",
      "Detox & Healing Center",
      "Hydrotherapy Spa",
      "Holistic Wellness Spa",
      "Spa & Wellness Center"
    ],
  },
  {
    type: "Print Shop",
    subtype: "Your Printing Solutions Partner",
    icon: "svg/printer.svg",
    subtypes: [
      "Digital Printing",
      "Offset Printing",
      "Business Cards & Stationery Printing",
      "Flyers & Brochures Printing",
      "Poster & Banner Printing",
      "Custom T-Shirt Printing",
      "Packaging & Label Printing",
      "Book & Magazine Printing",
      "3D Printing",
      "Corporate Printing Solutions",
      "Print Shop"
    ],
  },
  {
    type: "School",
    subtype: "Education for a Brighter Future",
    icon: "svg/school-icon.svg",
    subtypes: [
      "Pre-Primary School",
      "Primary School",
      "Secondary School",
      "Senior Secondary School",
      "Play School",
      "Montessori School",
      "International School",
      "Boarding School",
      "Special Education School",
      "CBSE/ICSE/IB Curriculum School",
      "School"
    ],

  },
  {
    type: "Colleges & Universities",
    subtype: "Higher Learning Institution",
    icon: "svg/school-icon.svg",
    subtypes: [
      "Engineering College",
      "Law College",
      "Business School (B-School)",
      "Arts & Science College",
      "Commerce College",
      "Pharmacy College",
      "Agricultural University",
      "Distance Learning University",
      "Research & Innovation Institutes",
      "Colleges & Universities"
    ],
  },
  {
    type: "Training Center",
    subtype: "Skill Development Hub",
    icon: "svg/Training Center-icon.svg",
    subtypes: [
      "Vocational Training Center",
      "IT & Computer Training",
      "Language Training Institute",
      "Soft Skills Training",
      "Corporate Training",
      "Competitive Exam Coaching",
      "Industrial Training",
      "Personality Development Training",
      "Technical Training",
      "Creative Arts Training",
      "Training Center"
    ],
  },
  {
    type: "Educational Institute",
    subtype: "Knowledge Empowerment Center",
    icon: "svg/school-icon.svg",
    subtypes: [
      "Coaching Institute",
      "Tutoring Center",
      "Research Institute",
      "Polytechnic Institute",
      "Professional Certification Center",
      "Distance Learning Institute",
      "Arts & Cultural Institute",
      "Science & Technology Institute",
      "Public Policy Institute",
      "E-Learning Platforms",
      "Educational Institute"
    ],
  },
  {
    type: "Plumber",
    subtype: "Water System Specialist",
    icon: "svg/Plumber-icon.svg",
    subtypes: [
      "Residential Plumbing Services",
      "Commercial Plumbing Services",
      "Industrial Plumbing Solutions",
      "Pipe Installation & Maintenance",
      "Drainage & Sewer Cleaning",
      "Leak Detection & Repair",
      "Bathroom & Kitchen Fittings",
      "Water Heater Installation & Repair",
      "Water Tank Cleaning & Maintenance",
      "Emergency Plumbing Services",
      "Plumber"
    ],
  },
  {
    type: "Roofers",
    subtype: "Roofing Specialists",
    icon: "svg/Roofer-icon.svg",
    subtypes: [
      "Residential Roofing",
      "Commercial Roofing",
      "Roof Repair & Maintenance",
      "Roof Installation",
      "Roof Inspection",
      "Gutter Installation & Repair",
      "Skylight Installation",
      "Roof Waterproofing",
      "Roof Replacement",
      "Emergency Roof Repair",
      "Roofers"
    ],
  },
  {
    type: "HVAC Services",
    subtype: "Heating, Ventilation & Air Conditioning",
    icon: "svg/HVAC Services-icon.svg",
    subtypes: [
      "HVAC Installation",
      "HVAC Repair & Maintenance",
      "Air Conditioner Services",
      "Heater & Furnace Services",
      "Ventilation System Services",
      "Duct Cleaning & Sealing",
      "Thermostat Installation & Repair",
      "Indoor Air Quality Solutions",
      "Commercial HVAC Services",
      "Residential HVAC Services",
      "HVAC Services"
    ],
  }
  ,
  {
    type: "Home Services",
    subtype: "Home Maintenance & Repair",
    icon: "svg/Home-Services-icon.svg",
    services: [
      "Commercial Plumbing Services",
      "Plumbing Services",
      "Construction Plumbing Contractor",
      "Painting & Wall Finishing",
      "New Construction",
      "Retail Buildings",
      "Car Washes & Showrooms",
      "Multi-Unit Housing",
      "Government Buildings",
      "Commercial Buildings",
      "Home Renovation & Repair",
      "Handyman Services",
      "Other",
    ],
  },
  {
    type: "Electrician",
    subtype: "Electrician",
    icon: "svg/Electrician_icon.svg",
    services: [
      "Residential Services",
      "Commercial & Office Services",
      "Safety & Maintenance",
      "New Wiring & Rewiring",
      "Switchboard & Socket Installation",
      "Lighting & Fan Fitting",
      "MCB & Distribution Board (DB) Repair",
      "Geyser & AC Connection",
      "Inverter & UPS Setup",
      "Earthing (Grounding)",
      "Fault Finding & Maintenance",
      "Other",
    ],
  },
  {
    type: "Compliance & Inspection Services",
    subtype: "Regulatory & Safety Assurance",
    icon: "svg/Compliance & Inspection Services-icon.svg",
    subtypes: [
      "Fire Safety Inspection",
      "Building Code Compliance",
      "Environmental Compliance",
      "Health & Safety Auditing",
      "Food Safety Inspection",
      "Electrical Safety Inspection",
      "OSHA Compliance Services",
      "Quality Assurance & Auditing",
      "License & Permit Compliance",
      "Third-Party Inspection Services",
      "Compliance & Inspection Services"
    ],
  },
  {
    type: "B2B Equipment & Solutions",
    subtype: "Business Equipment & Supply",
    icon: "svg/B2B Equipment & Solutions-icon.svg",
    subtypes: [
      "Office Equipment Supplier",
      "Industrial Machinery Supplier",
      "IT Hardware & Networking Solutions",
      "Medical Equipment Supplier",
      "Heavy Equipment Rental",
      "Restaurant & Kitchen Equipment",
      "Safety & Security Equipment",
      "Printing & Packaging Equipment",
      "Clean Energy Equipment",
      "Warehouse & Logistics Equipment",
      "B2B Equipment & Solutions"
    ],
  },
  {
    type: "Flooring",
    subtype: "Floor Installation & Repair",
    icon: "svg/Flooring-icon.svg",
    subtypes: [
      "Hardwood Flooring",
      "Laminate Flooring",
      "Vinyl & LVP Flooring",
      "Tile & Stone Flooring",
      "Carpet Installation",
      "Epoxy Flooring",
      "Bamboo Flooring",
      "Cork Flooring",
      "Concrete Flooring",
      "Floor Refinishing & Restoration",
      "Commercial Flooring",
      "Flooring"
    ],
  },
  {
    type: "Engineering",
    subtype: "Technical Engineering Solutions",
    icon: "svg/Engineering_icon.svg",
    subtypes: [
      "Civil Engineer",
      "Mechanical Engineer",
      "Electrical Engineer",
      "Structural Engineer",
      "Software Engineer",
      "Chemical Engineer",
      "Environmental Engineer",
      "Geotechnical Engineer",
      "Industrial Engineer",
      "Aerospace Engineer",
      "Petroleum Engineer",
      "Biomedical Engineer",
      "Engineering"
    ],
  },
  {
    type: "Law Firm",
    subtype: "Legal Services & Advisory",
    icon: "svg/Law Firm_icon.svg",
    subtypes: [
      "Corporate Law Services",
      "Criminal Defense Law",
      "Family Law (Divorce, Custody)",
      "Civil Litigation",
      "Property & Real Estate Law",
      "Intellectual Property Law",
      "Tax & Financial Law",
      "Labour & Employment Law",
      "Immigration Law Services",
      "Legal Consultancy",
      "Contract Drafting & Review",
      "Legal Documentation Services",
      "Law Firm"
    ],
  },
  {
    type: "General Contractor",
    subtype: "General Contractor",
    icon: "svg/General Contractor-icon.svg",
    subtypes: [
      "General Contractor"
    ],
  }
];

// nn